module.exports = __webpack_public_path__ + "img/gecko-screen.55b706d9.jpg";